/* tslint:disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull web-prod'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 4
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.eu.amplitude.com/lastminute-com/Lastminute%20-%20Production/events/main/latest)
 *
 * [Full Setup Instructions](https://data.eu.amplitude.com/lastminute-com/Lastminute%20-%20Production/implementation/web-prod)
 */

import * as amplitude from '@amplitude/analytics-browser';

export type Environment = 'lastminuteproduction';

export const ApiKey: Record<Environment, string> = {
  lastminuteproduction: '7644e7744755eaf2b99a0428f64e9250',
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '4',
    branch: 'main',
    source: 'web-prod',
    versionId: 'bda1f515-62e7-4d85-b9c8-2ec9569fe3c2',
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0',
    },
  },
  serverZone: amplitude.Types.ServerZone.EU,
};

export interface LoadOptionsBase {
  disabled?: boolean;
}

export type LoadOptionsWithEnvironment = LoadOptionsBase & {
  environment: Environment;
  client?: { configuration?: BrowserOptions };
};
export type LoadOptionsWithApiKey = LoadOptionsBase & { client: { apiKey: string; configuration?: BrowserOptions } };
export type LoadOptionsWithClientInstance = LoadOptionsBase & { client: { instance: BrowserClient } };

export type LoadOptions = LoadOptionsWithEnvironment | LoadOptionsWithApiKey | LoadOptionsWithClientInstance;

export interface ProductDetailsShownProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  '[Amplitude] Page Domain'?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  '[Amplitude] Page Location'?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  '[Amplitude] Page Path'?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  '[Amplitude] Page Title'?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  '[Amplitude] Page URL'?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  '[Amplitude] Previous Page Location'?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  '[Amplitude] Previous Page Type'?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  'ab test name'?: string[];
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  'ab test version'?: string[];
  'accommodation type': string;
  'amenities flag'?: boolean;
  'description flag'?: boolean;
  /**
   * Unique identifier of the product detail page (productDetailKey)
   */
  'detail page id': string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Unique Items | true |
   * | Item Type | string |
   */
  'features enabled'?: string[];
  'internal hotel id': string;
  'meal plan class': string;
  'provider id': string;
  'response code': string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  'room option qty': number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  'room qty'?: number;
  /**
   * Unique Identifier of search (uuid-1234-abcd).
   */
  'search id': string;
  /**
   * Type of search: DP or H.
   */
  'search type': string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  'total price eur': number;
  /**
   * User id from Casper when  the user has accepted the cookie category "Measurement"
   */
  uuid: string;
}

export interface ProductSelectedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  '[Amplitude] Page Domain'?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  '[Amplitude] Page Location'?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  '[Amplitude] Page Path'?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  '[Amplitude] Page Title'?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  '[Amplitude] Page URL'?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  '[Amplitude] Previous Page Location'?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  '[Amplitude] Previous Page Type'?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  'ab test name'?: string[];
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  'ab test version'?: string[];
  /**
   * Unique identifier of the product detail page (productDetailKey)
   */
  'detail page id': string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Unique Items | true |
   * | Item Type | string |
   */
  'features enabled'?: string[];
  /**
   * Unique Identifier of search (uuid-1234-abcd).
   */
  'search id': string;
  /**
   * Type of search: DP or H.
   */
  'search type': string;
  /**
   * User id from Casper when  the user has accepted the cookie category "Measurement"
   */
  uuid: string;
}

export interface ResultShownProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  '[Amplitude] Page Domain'?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  '[Amplitude] Page Location'?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  '[Amplitude] Page Path'?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  '[Amplitude] Page Title'?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  '[Amplitude] Page URL'?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  '[Amplitude] Previous Page Location'?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  '[Amplitude] Previous Page Type'?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  'ab test name'?: string[];
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  'ab test version'?: string[];
  /**
   * Total alternative accommodations.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  'alternative accommodation qty': number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Unique Items | true |
   * | Item Type | string |
   */
  'features enabled'?: string[];
  /**
   * Page index where user lands.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  'page id': number;
  /**
   * Total number of results on current page.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  'result qty': number;
  /**
   * The view shown to the customer (MAP, LIST)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | MAP, LIST |
   */
  'result view': 'MAP' | 'LIST';
  /**
   * Unique Identifier of search (uuid-1234-abcd).
   */
  'search id': string;
  /**
   * Type of search: DP or H.
   */
  'search type': string;
  /**
   * User id from Casper when  the user has accepted the cookie category "Measurement"
   */
  uuid: string;
}

export interface SearchRequestedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  '[Amplitude] Page Domain'?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  '[Amplitude] Page Location'?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  '[Amplitude] Page Path'?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  '[Amplitude] Page Title'?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  '[Amplitude] Page URL'?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  '[Amplitude] Previous Page Location'?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  '[Amplitude] Previous Page Type'?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  'ab test name'?: string[];
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  'ab test version'?: string[];
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  'adult qty': number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  'child qty': number;
  departure?: string;
  'departure date from'?: string;
  'departure date to'?: string;
  destination: string;
  /**
   * The name of the destination
   */
  'destination name'?: string;
  'destination type': string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Unique Items | true |
   * | Item Type | string |
   */
  'features enabled'?: string[];
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  'infant qty': number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  'length of stay max'?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  'length of stay min'?: number;
  'partial stay flag'?: boolean;
  'return date from'?: string;
  'return date to'?: string;
  'room details'?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  'room qty'?: number;
  /**
   * Unique Identifier of search (uuid-1234-abcd).
   */
  'search id': string;
  /**
   * Type of search: DP or H.
   */
  'search type': string;
  /**
   * User id from Casper when  the user has accepted the cookie category "Measurement"
   */
  uuid: string;
}

export class ProductDetailsShown implements BaseEvent {
  event_type = 'product details shown';

  constructor(public event_properties: ProductDetailsShownProperties) {
    this.event_properties = event_properties;
  }
}

export class ProductSelected implements BaseEvent {
  event_type = 'product selected';

  constructor(public event_properties: ProductSelectedProperties) {
    this.event_properties = event_properties;
  }
}

export class ResultShown implements BaseEvent {
  event_type = 'result shown';

  constructor(public event_properties: ResultShownProperties) {
    this.event_properties = event_properties;
  }
}

export class SearchRequested implements BaseEvent {
  event_type = 'search requested';

  constructor(public event_properties: SearchRequestedProperties) {
    this.event_properties = event_properties;
  }
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      // eslint-disable-next-line no-param-reassign
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

  /**
   * Flush the event.
   */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * product details shown
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/lastminute-com/Lastminute%20-%20Production/events/main/latest/product%20details%20shown)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  productDetailsShown(
    properties: ProductDetailsShownProperties,
    options?: EventOptions,
  ) {
    return this.track(new ProductDetailsShown(properties), options);
  }

  /**
   * product selected
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/lastminute-com/Lastminute%20-%20Production/events/main/latest/product%20selected)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  productSelected(
    properties: ProductSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ProductSelected(properties), options);
  }

  /**
   * result shown
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/lastminute-com/Lastminute%20-%20Production/events/main/latest/result%20shown)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  resultShown(
    properties: ResultShownProperties,
    options?: EventOptions,
  ) {
    return this.track(new ResultShown(properties), options);
  }

  /**
   * search requested
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/lastminute-com/Lastminute%20-%20Production/events/main/latest/search%20requested)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  searchRequested(
    properties: SearchRequestedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SearchRequested(properties), options);
  }
}

export const ampli = new Ampli();

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserClient = amplitude.Types.BrowserClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type IdentifyEvent = amplitude.Types.IdentifyEvent;
export type GroupEvent = amplitude.Types.GroupIdentifyEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
